/* eslint-disable eqeqeq */
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Home";
import Cookies from "js-cookie";
import Login from "./FrontEnd/Login/Login";

const App = () => {
  const isUserAuthenticated = () => {
    const store = Cookies.get("store");

    return store !== undefined;
  };

  return (
    <Router>
      <Routes>
        <Route
          path="*"
          element={isUserAuthenticated() ? <Home /> : <Login />}
        />
      </Routes>
    </Router>
  );
};

export default App;
